import type { RouteRecordRaw } from 'vue-router'
import LayoutApp from '@/views/layout-app.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/app',
    component: LayoutApp,
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/home/page-home.vue'),
        meta: { title: 'Home' },
      },
      {
        path: '/meja',
        name: 'table',
        component: () => import('@/views/table/page-table.vue'),
        meta: { title: 'Meja' },
      },
      {
        path: '/undangan',
        name: 'invitation',
        component: () => import('@/views/invitation/page-invitation.vue'),
        meta: { title: 'Undangan' },
      },
      {
        path: '/kedatangan',
        name: 'arrival',
        component: () => import('@/views/arrival/page-arrival.vue'),
        meta: { title: 'Tamu Tiba' },
      },
      {
        path: '/ucapan',
        name: 'wishes',
        component: () => import('@/views/wishes/page-wishes.vue'),
        meta: { title: 'Wishes' },
      },
      {
        path: '/tim-kerja',
        name: 'team member',
        component: () => import('@/views/team-member/page-team-member.vue'),
        meta: { title: 'Tim Kerja' },
      },
      {
        path: '/galeri/:album?',
        name: 'gallery',
        component: () => import('@/views/gallery/page-gallery.vue'),
        meta: { title: 'Gallery' },
      },
      {
        path: '/scan-arrival',
        name: 'scan arrival',
        component: () => import('@/views/arrival/page-arrival-scan.vue'),
        meta: { title: 'Scan QR Code' },
      },
      {
        path: '/arrived',
        name: 'arrived',
        component: () => import('@/views/arrival/page-arrival.vue'),
        meta: { title: 'Arrived' },
      },
    ],
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/page-login.vue'),
    meta: { title: 'Masuk' },
  },
]

export default routes
